import React from "react";
import Link from "./Link";
import {useMenuItems} from "/src/_hooks/useMenuItems";
import styled from "styled-components";

const Nav = styled.nav`
  .navbar-nav {
    --bs-nav-link-hover-color: var(--bs-lime-green);
    --bs-nav-link-color: var(--bs-white);
    --bs-navbar-active-color: var(--bs-lime-green);
  }
  .nav-link {
    &:after{
      content: '';
      position: absolute;
      top: 100%;
      left: 1px;
      right: 1px;
      height: 0;
      border-top: 1px dashed currentColor;
      transition: transform 0.15s ease-out;
      transform-origin: 0 0;
      transform: scaleY(0);
    }

    &:hover {
      &:after{
        transform: scaleY(1);
      }
    }
  }
`

const MenuFooterBottom = ({location}) => {
  const menuItems = useMenuItems(location);

  return menuItems?.length > 0 ? (
    <Nav>
      <ul className="navbar-nav flex-row gap-24 justify-content-lg-around align-items-center">
        {menuItems.map((menuItem, index) => (
            <li className={`nav-item`} key={menuItem.id + index}>
              <Link className="nav-link fw-700 fs-14 letter-spacing-n015 lh-125 position-relative" to={menuItem.path} target={menuItem.target}>
                {menuItem.label}
              </Link>
            </li>
          )
        )}
      </ul>
    </Nav>
  ) : null;
}

export default MenuFooterBottom
